import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useEnableUnifiedMenu = () => {
  const isUnifiedMenuEnabled = useFlag(LaunchDarklyFlag.ENABLE_UNIFIED_MENU);
  return Boolean(isUnifiedMenuEnabled);
};
